import { hideBreakLinesFromScreenReaders } from '@msc-b2c/shared-utils';

export function accessibilityLogic() {
  function onDocumentReady() {
    hideBreakLinesFromScreenReaders(document);

    // skip unwanted nodes
    const skipTags = new Set(['SCRIPT', 'STYLE', 'LINK']);

    // add mutation observer to put aria-hidden true also for react components
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            if (skipTags.has(node.tagName)) return;
            hideBreakLinesFromScreenReaders(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

accessibilityLogic();
